import React, { useState, useEffect, useRef, forwardRef } from "react";
import { useHistory } from "react-router-dom";
import {TextField,
        Grid,
        Box,
        Button,
        CircularProgress,
        Tabs,
        Tab,
        AppBar,
        Typography,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
} from "@material-ui/core";
import {OpenInNew as OpenInNewIcon
} from '@material-ui/icons';
import PropTypes from 'prop-types';
//import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import Widget from '../../components/Widget';
import Pricing from '../../components/Pricing/Pricing';
import { sendNotification } from "../../context/UserContext";
import config from '../../config';
import { useUserState } from "../../context/UserContext"
import { Link } from '../../components/Wrappers'
import SelectCustomer from '../../components/Customer/SelectCustomer';
import UpdateCustomer from '../../components/Customer/UpdateCustomer';
import SelectSite from '../../components/Site/SelectSite';
import UpdateSite from '../../components/Site/UpdateSite';
import JobDetails from '../../components/JobDetails/JobDetails';
import SelectTechnicians from '../../components/Technician/SelectTechnicians';
import SiteRetests from '../../components/SiteRetest/SiteRetests';
import JobHistories from '../../components/JobHistories/JobHistories';
import VisitPatternPanel from '../../components/VisitPatternPanel/VisitPatternPanel';
import SchedulingChecklist from '../../components/SchedulingChecklist/SchedulingChecklist';

const BookJob = forwardRef((props, ref) => {
//export default function CreateSite(props, ref) {
    // global
    const classes = useStyles();
    const history = useHistory();

    var { single_phase_price, three_phase_price, rcd_price,
          fire_price, first_aid_price, medical_price, rcd_pb_price,
          lg_pb_price, lg_m_price, three_phase_rcd_price, microwave_price,
          non_electrical_price, ladder_price, aed_price, evse_price,
          hourly_charge, min_charge, local_travel, seventy_hundred_travel,
          over_100_travel, min_cash_charge } = useUserState();

    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [job, setJob] = useState(undefined);
    const [retest, setRetest] = useState(undefined);

    const [isSelectCustomerValid, setIsSelectCustomerValid] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [isSelectSiteValid, setIsSelectSiteValid] = useState(false);
    const [selectedSite, setSelectedSite] = useState(undefined);
    const createJobDetailsRef = useRef(null);
    const selectTechniciansRef = useRef(null);
    const siteRetestsRef = useRef(null);
    const [isCreateJobDetailsValid, setIsCreateJobDetailsValid] = useState(false);
    const [isSelectTechniciansValid, setIsSelectTechniciansValid] = useState(false);
    const [workers, setWorkers] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isSavingAndConfirming, setIsSavingAndConfirming] = useState(false);
    const [sitePricing, setSitePricing] = useState(undefined);
    const [isCreateSiteValid, setIsCreateSiteValid] = useState(false);
    const [siteTabValue, setSiteTabValue] = useState(1);
    const [currentSiteTabValue, setCurrentSiteTabValue] = useState(1);
    const [customerTabValue, setCustomerTabValue] = useState(0);
    const [oldJobId, setOldJobId] = useState(-1);
    const [newBookedJobId, setNewBookedJobId] = useState(-1);
    const [isRetestLoaded, setIsRetestLoaded] = useState(false);
    const [hasNoJobHistories, setHasNoJobHistories] = useState(false);

    const [openBookJobDialog, setOpenBookJobDialog] = useState(false);
    const [testScopesDirty, setTestScopesDirty] = useState(1);

    const [jsaMicrowaveSetted, setJsaMicrowaveSetted] = useState(false);
    const [servicesSetted, setServicesSetted] = useState(false);

    const GENERAL_CHECKLIST_YEAR_MONTH = "1900-01";
    const [assetCoverageYearMonth, setAssetCoverageYearMonth] = useState(GENERAL_CHECKLIST_YEAR_MONTH);

    const [qualifiedTechWarningRequired, setQualifiedTechWarningRequired] = useState(false);


    function TabPanel(props) {
      const { children, value, index, ...other } = props;
      return (

        <div
          role="tabpanel"
          style={{visibility: value !== index ? 'hidden' : 'visibility'}}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }//);

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    useEffect(() => {//console.log(locationState, paramsId);
        let mounted = true;
        const retestId = locationState === undefined ? paramsId : locationState.retestId;
        //const pathName = props.location.pathname;
        //console.log('test',pathName.includes('/site/retest/book/'),props.match.params.id)
        //const isBookFromSiteLatestClosedJob = pathName.includes('/site/retest/book/');
        const isBookFromSiteLatestClosedJob = isBookThroughSite();

        async function fetchData() {
            var response = null;
            if (isBookFromSiteLatestClosedJob) {
                const siteId = props.match.params.id;
                response = await ttAPI.loadRetest(null,siteId);
            }
            else {
                response = await ttAPI.loadRetest(retestId, null);
            }

            setRetest(response);
            //console.log('retest response',response);
            //console.log(response);
            if (response && response !== null) {
                const isRetest = response.is_retest !== undefined && response.is_retest !== null && response.is_retest;
                if(mounted){
                    var contact = `${response.site_contact !== null && response.site_contact !== undefined && response.site_contact !== '' ? `${response.site_contact} ` : ''}`;
                    var phone = `${response.site_phone !== null && response.site_phone !== undefined && response.site_phone !== '' ? `${response.site_phone} ` : ''}`;
                    var email = `${response.site_email !== null && response.site_email !== undefined && response.site_email !== '' ? `${response.site_email} ` : ''}`;
                    contact = `${contact}${phone}${email}`;
                    if (isRetest) {
                        setOldJobId(response.job_id);
                        const oldJobResponse = await ttAPI.loadJob(response.job_id);
                        setJob({
                          ...job,
                          customer_id: response.customer_id,
                          site_id: response.site_id,
                          franchise_id: oldJobResponse.franchise_id,
                          instructions:  `${response.site_total_assets} assets due to expire on ${response.expiry_month}.\n${oldJobResponse.instructions}`,
                          //contact: oldJobResponse.contact,
                          contact: contact, // we want the latest site contact
                          is_in_region: true
                        });
                        await onRegionSelected(oldJobResponse.franchise_id);
                    }
                    else {
                      // NOTES: should not end up here anymore, but keep it just in case.
                      // the servlet /dashboard/retest always return is_retest as true unless I missed any usage
                        setOldJobId(response.id);
                        setJob({
                          ...job,
                          customer_id: response.customer_id,
                          site_id: response.site_id,
                          franchise_id: response.franchise_id,
                          instructions: response.instructions,
                          //contact: response.contact,
                          contact: contact, // we want the latest site contact
                          is_in_region: true
                        });
                        await onRegionSelected(response.franchise_id);
                    }
                }

              //const sitePricingResponse = await ttAPI.getSitePricing(response.site_id);
              //setSitePricing(sitePricingResponse);

              const customerLoaded = await ttAPI.getCustomerById(response.customer_id);
              if(mounted){
                  setSelectedCustomer(customerLoaded);
              }

              const siteLoaded = await ttAPI.getSiteById(response.site_id);
              if(mounted){
                  setSelectedSite(siteLoaded);
              }
            }
            else {
              // for trying to book job from customer>site, but the site
              // is relatively new thus no historical jobs available
              if (isBookFromSiteLatestClosedJob) {
                const siteId = props.match.params.id;
                const siteLoaded = await ttAPI.getSiteById(siteId);
                if(mounted){
                    setSelectedSite(siteLoaded);
                }
                const customerLoaded = await ttAPI.getCustomerById(siteLoaded.customer_id);
                if(mounted){

                    var contact = `${siteLoaded.contact !== null && siteLoaded.contact !== undefined && siteLoaded.contact !== '' ? `${siteLoaded.contact} ` : ''}`;
                    var phone = `${siteLoaded.phone !== null && siteLoaded.phone !== undefined && siteLoaded.phone !== '' ? `${siteLoaded.phone} ` : ''}`;
                    var email = `${siteLoaded.email !== null && siteLoaded.email !== undefined && siteLoaded.email !== '' ? `${siteLoaded.email} ` : ''}`;
                    contact = `${contact}${phone}${email}`


                    setJob({
                      ...job,
                      customer_id: customerLoaded.id,
                      site_id: siteLoaded.id,
                      contact: contact,
                      is_in_region: true
                    });
                    setSelectedCustomer(customerLoaded);
                }

                setHasNoJobHistories(true);
              }

            }
            setIsRetestLoaded(true);

        }

        if (mounted && retestId !== undefined && retestId > 0) {
            fetchData();
        }

        return () => mounted = false;
    },[locationState, paramsId]);

    useEffect(() => {
        async function bookRetest() {
            const retestId = locationState === undefined ? paramsId : locationState.retestId;
            await ttAPI.bookRetest(retestId,newBookedJobId);
            history.push({
              pathname:`/app/job/edit/${newBookedJobId}`,
              state:{jobId: newBookedJobId, isFromBookJob: true}
            });
        }

        async function bookSiteRetest() {
            const siteId = locationState === undefined ? paramsId : locationState.siteId;
            await ttAPI.bookSiteRetest(siteId,newBookedJobId);
            history.push({
              pathname:`/app/job/edit/${newBookedJobId}`,
              state:{jobId: newBookedJobId, isFromBookJob: true}
            });
        }

        const isBookFromSiteLatestClosedJob = isBookThroughSite();
        // TODO: figure out what to do with any related retests if you book from site
        if (newBookedJobId > 0) {
            if (isBookFromSiteLatestClosedJob) {
                bookSiteRetest();
            }
            else {
                bookRetest();
            }

        }

    }, [newBookedJobId]);

    useEffect(() => {
      if (selectedCustomer !== undefined && selectedCustomer != null) {
        setJob({
          ...job,
          jsa_required: selectedCustomer.jsa_required,
          microwave_only: selectedCustomer.microwave_only
        });
        setJsaMicrowaveSetted(true);
      }
    },[selectedCustomer]);

    useEffect(() => {
      async function fetchData() {
        const sitePricingResponse = await ttAPI.getSitePricing(selectedSite.id);
        setSitePricing(sitePricingResponse);
      }
      if (selectedSite !== undefined && selectedSite !== null && selectedSite.id > 0) {
          fetchData();
          setJob({
            ...job,
            testing_scopes: selectedSite.testing_scopes,
            testing_scope_other_notes: selectedSite.testing_scope_other_notes
          });
          setServicesSetted(true);
      }

    }, [selectedSite]);


    /*useEffect(() => {
      console.log('useeffect siteTabValue changed',siteTabValue)

    }, [siteTabValue]);*/



    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
      /*setJob({
        ...job,
        customer_id: customer === undefined || customer === null ? -1 : customer.id,
        jsa_required: customer === undefined || customer === null ? null : customer.jsa_required,
        microwave_only: customer === undefined || customer === null ? null : customer.microwave_only
      });*/
    }

    function onSelectCustomerFormUpdated(isValid) {
      setIsSelectCustomerValid(isValid);
    }

    function onSelectSite(site) {
      setSelectedSite(site);
      setJob({
        ...job,
        site_id: site === undefined || site === null ? -1 : site.id
      });
    }

    function onSelectSiteFormUpdated(isValid) {
      setIsSelectSiteValid(isValid);
    }

    function onCreateJobDetailsFormUpdated(isValid) {
        setIsCreateJobDetailsValid(isValid);
    }

    function onCreateJobDetailsUpdated(createdJob) {
      console.log('onCreateJobDetailsUpdated',job)
        //setJob(job);
        setJob({
          ...job,
          start: createdJob.start,
          finish: createdJob.finish,
          code: createdJob.code,
          contact: createdJob.contact,
          instructions: createdJob.instructions,
          tag: createdJob.tag,
          franchise_id: createdJob.franchise_id,
          is_in_region: createdJob.is_in_region,
          has_important_instruction: createdJob.has_important_instruction,
          is_nfc: createdJob.is_nfc,
          is_cataloguing: createdJob.is_cataloguing,
          jsa_required: createdJob.jsa_required,
          microwave_only: createdJob.microwave_only,
          testing_scopes: createdJob.testing_scopes,
          testing_scope_other_notes: createdJob.testing_scope_other_notes
        });
    }

    function onJobDetailsCreated(updatedJob) {//console.log('onJobDetailsCreated',job)
      setJob({
        ...job,
        start: updatedJob.start,
        finish: updatedJob.finish,
        code: updatedJob.code,
        contact: updatedJob.contact,
        instructions: updatedJob.instructions,
        tag: updatedJob.tag,
        franchise_id: updatedJob.franchise_id,
        is_in_region: updatedJob.is_in_region,
        has_important_instruction: updatedJob.has_important_instruction,
        is_nfc: updatedJob.is_nfc,
        is_cataloguing: updatedJob.is_cataloguing,
        jsa_required: updatedJob.jsa_required,
        microwave_only: updatedJob.microwave_only,
        testing_scopes: updatedJob.testing_scopes,
        testing_scope_other_notes: updatedJob.testing_scope_other_notes
      });
    }

    async function onRegionSelected(regionId) {//console.log('onRegionSelected',regionId)
      if (job === undefined || job === null) {
        if (regionId > 0) {
          const response = await ttAPI.getActiveWorkersByRegion(regionId);
          setWorkers(response);
        }
        else {
          const response = await ttAPI.getActiveWorkers();
          setWorkers(response);
        }
      }
      else {
        if (job.is_in_region && regionId > 0) {
          const response = await ttAPI.getActiveWorkersByRegion(regionId);
          setWorkers(response);
        }
        else {
          const response = await ttAPI.getActiveWorkers();
          setWorkers(response);
        }
        if (selectTechniciansRef.current) {
          selectTechniciansRef.current.updateLeaderWokersSelection(job.is_in_region);
        }
      }

    }

    async function onIsInRegionSelected(isInRegionValue) {//console.log('onIsInRegionSelected',job)
      setJob({
        ...job,
        is_in_region: isInRegionValue === 'YES'
      });
       // is in region workers allowed - changed, need to repull the workers list
       if (isInRegionValue === 'YES' && job !== undefined && job !== null && job.franchise_id > 0) {
         const response = await ttAPI.getActiveWorkersByRegion(job.franchise_id);
         setWorkers(response);
       }
       else {
         const response = await ttAPI.getActiveWorkers();
         setWorkers(response);
       }
       if (selectTechniciansRef.current) {
         selectTechniciansRef.current.updateLeaderWokersSelection(isInRegionValue);
       }
    }

    function onSelectTechniciansFormUpdated(isValid) {
        setIsSelectTechniciansValid(isValid);
    }

    function onTechniciansSelected(workers) {//console.log('onTechniciansSelected',job)
        setJob({
          ...job,
          workers: workers,
        });
    }

    function onLeaderSelected(leader) {//console.log('onLeaderSelected',job)
       if (leader !== null && leader !== undefined && !isNaN(leader)) {
         setJob({
           ...job,
           leader: leader
         });
         setIsSelectTechniciansValid(true);
       }

    }

    const disableSaveButton = () => {//console.log('12');
      return (isSaving || isSavingAndConfirming) || !(isSelectCustomerValid && isSelectSiteValid && isCreateJobDetailsValid && isSelectTechniciansValid);
    }

    const handleFinish = async (isConfirmed) => {
        const jobToSend = job;

        if (isConfirmed !== undefined && isConfirmed) {
            jobToSend.confirmed = true;
        }

        if (jobToSend.workers) {
            jobToSend.workers = jobToSend.workers.map(worker => worker.id === undefined ? worker : worker.id);
        }

        if (jobToSend.testing_scopes !== undefined && jobToSend.testing_scopes !== null) {
            jobToSend.testing_scopes = jobToSend.testing_scopes.map(testing_scope => isNaN(testing_scope) ? testing_scope.id : testing_scope);
            const isTELtag = jobToSend.testing_scopes?.some(scope =>
              typeof scope === 'object' ? scope.id === 11 : scope === 11
            );

            // the following two setups must come with TELtag
            if (isTELtag) {
              jobToSend.is_nfc = true;
              jobToSend.is_cataloguing = true;
            }
        }

        jobToSend.start = jobToSend.start.replace('T', ' ');
        jobToSend.finish = jobToSend.finish.replace('T', ' ');

        if (jobToSend.start.split(':').length == 2) {
            jobToSend.start = jobToSend.start.concat(':00');
        }

        if (jobToSend.finish.split(':').length == 2) {
            jobToSend.finish = jobToSend.finish.concat(':00');
        }

        if (isConfirmed !== undefined && isConfirmed) {
            setIsSavingAndConfirming(true);
        }
        else {
            setIsSaving(true);
        }
        setNewBookedJobId(-1);
        const response = await ttAPI.saveJob(jobToSend);
        if (response.id > 0) {
          if (isConfirmed !== undefined && isConfirmed) {
              ttAPI.sendJobSheet(response.id);
              if (localStorage.getItem('auto_open_teams_link_after_job_confirmation') === 'true') {
                  openTeamChatWithJobCardLink(response.id, response.jobcard_token);
              }
              setIsSavingAndConfirming(false);
          }
          else {
              setIsSaving(false);
          }

          setNewBookedJobId(response.id);
          // update retest records
          setRetest({
            ...retest,
            booked_job_id: response.id
          });

          /*history.push({
            pathname:`/app/job/edit/${response.id}`,
            state:{jobId: response.id, isFromBookJob: true}
          });*/
        }
        else {
          if (isConfirmed !== undefined && isConfirmed) {
              setIsSavingAndConfirming(false);
          }
          else {
              setIsSaving(false);
          }
          sendNotification('error', `${response.error}`, classes);
        }
    }

    const openTeamChatWithJobCardLink = async (jobId, jobcard_token) => {
      var emails = await ttAPI.getJobWorkerEmails(jobId);
      if (emails !== null && emails !== undefined && emails !== '' && emails !== 'null') {
        window.open(
        `${config.teamChatWithMessageUrl.replace('<USERS>', emails).replace('<TOPIC_NAME>',`Job%20${jobId}%20Chat`).replace('<CONTENT>',`Job ${jobId} has been confirmed. An email was sent and you can download a copy of the job card from here as well: ${config.clientApi}/dashboard/job_sheet?jobId=${jobId}${encodeURIComponent('&')}jobcard_token=${jobcard_token}`)}`,
        '_blank'
        );
      }
      else {
        sendNotification('error','Cannot open a team chat as there are no technicians are assigned to the job.', classes);
      }
    }

    /*function onInstructionsUpdated(updatedJobInstructions) {
        var total = siteRetestsRef.current.getTotalSiteAssetsAdded(updatedJobInstructions);
        if(updatedJobInstructions.includes("Estimated total assets due:")) {
            if (!updatedJobInstructions.includes(`Estimated total assets due: ${total}`)) {
                var newInstructions = updatedJobInstructions.replace(updatedJobInstructions.slice(0, updatedJobInstructions.indexOf('\n')+1),`Estimated total assets due: ${total}.\n`);
                setJob({
                  ...job,
                  instructions: newInstructions,
                });
                createJobDetailsRef.current.updateInstructions(newInstructions);
            }
        }
    }*/

    function onClickCopyExpiryInSiteRetestsList(expiringAssets, expiredMonth, oldTotalAssetsDue, totalAssetsDue) {
      //console.log('onRowSelectedInSiteRetestsList', expiringAssets, expiredMonth);
      //console.log('onClickCopyExpiryInSiteRetestsList', totalAssetsDue);

      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;
      var newExpiryRow = `${expiringAssets} assets due to expire on ${expiredMonth}.\n`;

      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}${newExpiryRow}`.trim());
      }
      else {
          newInstructions = `${totalRow}${newExpiryRow}${job.instructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickRemoveExpiryInSiteRetestsList(expiringAssets, expiredMonth, totalAssetsDue) {
      //console.log('onRowSelectedInSiteRetestsList', expiringAssets, expiredMonth);
      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;
      var expiryRowToRemove = `${expiringAssets} assets due to expire on ${expiredMonth}.\n`;
      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}`.trim()).replace(expiryRowToRemove, '');
      }
      else {
          newInstructions = `${totalRow}${job.instructions.replace(expiryRowToRemove, '')}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickCopyAllExpiryInSiteRetestsList(totalAssetsDue, data) {
      var newInstructions = job.instructions;
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?.*/i);

      let result = job.instructions.matchAll(/\s?[0-9]+\s?assets due to expire on.*/g);
      for (const match of result) {
          if (match !== null && match !== undefined && match[0] !== '') {
              newInstructions = newInstructions.replace(match[0],'');
          }
      }

      var newExpiryRows = '';
      for (const d of data) {
          newExpiryRows += `${d.assets} assets due to expire on ${d.expiry}.\n`;
      }

      var totalRow = `Estimated total assets due: ${totalAssetsDue}.\n`;


      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = newInstructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = newInstructions.replace(newInstructions.slice(start, end),`${totalRow}${newExpiryRows}`.trim());
      }
      else {
          newInstructions = `${totalRow}${newExpiryRows}${newInstructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function onClickRemoveAllExpiryInSiteRetestsList() {
        var newInstructions = job.instructions;
        var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?.*/i);
        if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
            newInstructions = newInstructions.replace(estimatedTotalText[0],'');
        }

        let result = newInstructions.matchAll(/\s?[0-9]+\s?assets due to expire on.*/g);
        for (const match of result) {
            if (match !== null && match !== undefined && match[0] !== '') {
                newInstructions = newInstructions.replace(match[0],'');
            }
        }

        setJob({
          ...job,
          instructions: newInstructions,
        });
        createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function containsCopiedInstructions(expiringAssets, expiredMonth) {
      return job.instructions === undefined || job.instructions === null ? '' : job.instructions.includes(`${expiringAssets} assets due to expire on ${expiredMonth}`);
    }

    function addTotalSelectedAssetsToInstructions(total) {
      var newInstructions = '';
      var estimatedTotalText = job.instructions.match(/Estimated total assets due:\s?[0-9]+/i);
      var totalRow = `Estimated total assets due: ${total}.\n`;

      if (estimatedTotalText !== undefined && estimatedTotalText !== null && estimatedTotalText[0] !== '') {
          var start = job.instructions.indexOf(estimatedTotalText[0]);
          var end = start + estimatedTotalText[0].length + 1;
          newInstructions = job.instructions.replace(job.instructions.slice(start, end),`${totalRow}`.trim());
      }
      else {
          newInstructions = `${totalRow}${job.instructions}`;
      }

      setJob({
        ...job,
        instructions: newInstructions,
      });
      createJobDetailsRef.current.updateInstructions(newInstructions);
    }

    function handleSiteTabChange(event, newValue) {//console.log('handleSiteTabChange', newValue)
      setSiteTabValue(newValue);
    }

    function handleCustomerTabChange(event, newValue) {
      setCustomerTabValue(newValue);
    }

    function getSiteName() {
      return selectedSite !== undefined && selectedSite !== null ? selectedSite.name : '';
    }

    function onUpdateCustomerSuccess() {

    }

    function onUpdateSiteSuccess() {

    }

    function openBookedJob() {
        window.open(`${config.adminApi}/#/app/job/edit/${retest.booked_job_id}`,'_blank');
    }

    function isBookThroughSite() {
        return props !== undefined && props !== null &&
               props.location !== undefined && props.location !== null &&
               props.location.pathname !== undefined &&
               props.location.pathname !== null &&
               props.location.pathname.includes('/site/retest/book/');
    }

    const handleCloseBookJobDialog = () => {
      setOpenBookJobDialog(false);
    };

    const checkBeforeBookJob = async (isConfirmed) => {
          if (retest !== undefined && retest !== null &&
           retest.booked_job_id !== undefined && retest.booked_job_id !== null &&
           retest.booked_job_id > 0) {
               setOpenBookJobDialog(true);
           }
           else {
               await handleFinish(isConfirmed);
           }
    }

    function onTestingScopesChanged(testingScopes) {
        selectTechniciansRef.current.updateTestingScopes(testingScopes);
        setTestScopesDirty(Math.random());
    }

  return ( <>
    <div className={classes.contentDiv}>

    {/*<div>{`newJob.id is ${job.id}`}</div>
    <div>{`newJob.customerId is ${job.customer_id}`}</div>
    <div>{`newJob.siteId is ${job.site_id}`}</div>
    <div>{`newJob.regionId is ${job.franchise_id}`}</div>
    <div>{`newJob.tag is ${job.tag}`}</div>
    <div>{`newJob.start is ${job.start}`}</div>
    <div>{`newJob.finish is ${job.finish}`}</div>
    <div>{`newJob.contact is ${job.contact}`}</div>
    <div>{`newJob.leader is ${job.leader}`}</div>*/}
    {/*job === undefined && isRetestLoaded && isBookThroughSite()  &&
    <div>Sorry, cannot show retest details, it's because the site you've selected has no historical job. Please use the Add Job button above to create a new job for the site.</div>*/}
    {job &&
        <Grid container spacing={4}>
          {/*<Grid item xs={12} md={12} sm={12}>*/}
          <Grid item xs={12} md={6} sm={6}>
              <Box display={'flex'}
                  justifyContent={'flex-end'}
                  style={{marginBottom: '-20px', marginRight: '20px', marginTop: '20px'}}
              >
                  <Button style={{position: 'fixed', zIndex: '10', marginRight: '170px'}}
                      className={classes.saveBookJobButton}
                      variant="contained"
                      color="primary"
                      disabled={disableSaveButton()}
                      onClick={() => checkBeforeBookJob(false)}
                  >
                  {isSaving && <span><CircularProgress size={25}/> Booking...</span>}
                  {!isSaving && <span>Save</span>}
                  </Button>

                  <Button style={{position: 'fixed', zIndex: '10'}}
                      className={classes.saveBookJobButton}
                      variant="contained"
                      color="primary"
                      disabled={disableSaveButton()}
                      onClick={() => checkBeforeBookJob(true)}
                  >
                  {isSavingAndConfirming && <span><CircularProgress size={25}/> Booking and Confirming...</span>}
                  {!isSavingAndConfirming && <span>Save & Confirm</span>}
                  </Button>
              </Box>

              <Widget
                title={<><span>Book Job <span style={{color: 'orangered'}}>{retest !== undefined && retest !== null && retest.archived ? `ARCHIVED (${retest.archived_reason !== undefined && retest.archived_reason !== null ? retest.archived_reason : ''})` : ''}</span></span>
                  {retest !== undefined && retest !== null &&
                   retest.booked_job_id !== undefined && retest.booked_job_id !== null &&
                   retest.booked_job_id > 0 &&
                   <span>&nbsp;
                   (<Link style={{display: 'inline-flex'}}
                          href={`${config.adminApi}/#/app/job/edit/${retest.booked_job_id}`}
                          color="#FFCA06" target="_blank">
                          View Booked Job {retest.booked_job_id}<OpenInNewIcon style={{width:'15px', marginTop: '-5px'}}/></Link>)</span>}</>}
                upperTitle
                className={classes.card}
                bodyClass={classes.fullHeightBody}
                disableWidgetMenu
              >

              {/*<div className={classes.edit_job_customer_site_div}>
                <SelectCustomer labelName="Customer"
                                selectedCustomer={selectedCustomer}
                                onSelect={onSelectCustomer}
                                onFormUpdated={onSelectCustomerFormUpdated}/>

                <SelectSite labelName="Site"
                            selectedSite={selectedSite}
                            customerId={(selectedCustomer !== undefined && selectedCustomer !== null) ? selectedCustomer.id : -1}
                            onSelect={onSelectSite}
                            onFormUpdated={onSelectSiteFormUpdated}/>
              </div>*/}

              <div className={classes.inline}>
                   {/*}<div><span><b>Geographic Region:</b> {retest.site_geo_region_name}</span>,
                     <span><b>Geographic Locality:</b> {retest.site_geo_locality}</span><br/>
                   </div>*/}
                  <div>
                      <SelectCustomer labelName="Customer"
                                  selectedCustomer={selectedCustomer}
                                  onSelect={onSelectCustomer}
                                  onFormUpdated={onSelectCustomerFormUpdated}/>
                  </div>

                  <div>
                      <SelectSite labelName="Site"
                              selectedSite={selectedSite}
                              customerId={(selectedCustomer !== undefined && selectedCustomer !== null) ? selectedCustomer.id : -1}
                              onSelect={onSelectSite}
                              onFormUpdated={onSelectSiteFormUpdated}/>
                  </div>
              </div>

              {selectedCustomer !== undefined && selectedCustomer != null && selectedSite !== undefined && selectedSite != null && jsaMicrowaveSetted && servicesSetted && <JobDetails ref={createJobDetailsRef}
                          createdJob={job}
                          selectedCustomer={selectedCustomer}
                          onFormUpdated={onCreateJobDetailsFormUpdated}
                          onJobDetailsUpdated={onCreateJobDetailsUpdated}
                          onJobDetailsCreated={onJobDetailsCreated}
                          onRegionSelected={onRegionSelected}
                          onIsInRegionSelected={onIsInRegionSelected}
                          getSiteName={getSiteName}
                          onTestingScopesChanged={onTestingScopesChanged}
                          compact={true}
                          />}
                          {/*onInstructionsUpdated={onInstructionsUpdated}*/}
              {/*selectedCustomer !== undefined && selectedCustomer !== null &&
                selectedCustomer.require_vaccination_proof &&
                <div style={{color: '#f44336', marginTop: '-10px', marginBottom: '10px'}}>Proof of vaccination required!</div>*/}
              <SelectTechnicians ref={selectTechniciansRef}
                                 createdJob={job}
                                 onFormUpdated={onSelectTechniciansFormUpdated}
                                 workers={workers}
                                 onTechniciansSelected={onTechniciansSelected}
                                 onLeaderSelected={onLeaderSelected}
                                 dirty={testScopesDirty}
                                 compact={true}
                                 showQualifiedTechWarning={qualifiedTechWarningRequired}/>

              <div className={classes.bottomMenu}>
                  <div>
                  <Box
                      display={'flex'}
                      justifyContent={'flex-end'}
                  >
                      <Button
                          className={classes.saveBookJobButton}
                          variant="contained"
                          color="primary"
                          disabled={disableSaveButton()}
                          onClick={() => checkBeforeBookJob(false)}
                      >
                      {isSaving && <span><CircularProgress size={25}/> Booking Job...</span>}
                      {!isSaving && <span>Save</span>}
                      </Button>

                      <Button style={{marginLeft: '10px'}}
                          className={classes.saveBookJobButton}
                          variant="contained"
                          color="primary"
                          disabled={disableSaveButton()}
                          onClick={() => checkBeforeBookJob(true)}
                      >
                      {isSavingAndConfirming && <span><CircularProgress size={25}/> Booking and Confirming...</span>}
                      {!isSavingAndConfirming && <span>Save & Confirm</span>}
                      </Button>

                  </Box>
                  </div>
              </div>

            </Widget>

          </Grid>

          <Grid item xs={12} md={6} sm={6}>
            <Grid container spacing={4}>
            <Grid item xs={12} md={12} sm={12}>
              { job && job.site_id  && <SiteRetests
                                          ref={siteRetestsRef}
                                          site_id={job.site_id}
                                          customer_id={job.customer_id}
                                          id={locationState === undefined ? paramsId : locationState.retestId}
                                          onCopyExpiry={onClickCopyExpiryInSiteRetestsList}
                                          onRemoveExpiry={onClickRemoveExpiryInSiteRetestsList}
                                          onCopyAllExpiry={onClickCopyAllExpiryInSiteRetestsList}
                                          onRemoveAllExpiry={onClickRemoveAllExpiryInSiteRetestsList}
                                          onShowCopyExpiryButton={containsCopiedInstructions}
                                          onAddTotalSelectedToInstructions={addTotalSelectedAssetsToInstructions}
                                          onAssetCoverageYearMonthChange={setAssetCoverageYearMonth}
                                          onQualifiedTechWarningRequiredChange={setQualifiedTechWarningRequired}
                                        />}
            </Grid>

            {selectedSite && selectedSite.id > 0 && selectedCustomer && selectedCustomer.id > 0 && (
              <Grid item xs={12} md={12} sm={12}>
                <SchedulingChecklist
                  siteId={selectedSite.id}
                  customerId={selectedCustomer.id}
                  assetCoverageYearMonth={assetCoverageYearMonth || GENERAL_CHECKLIST_YEAR_MONTH}
                  jobId={null}
                />
              </Grid>
            )}

            {job && job.site_id && !isBookThroughSite() &&
              <Grid item xs={12} md={12} sm={12}>
              <VisitPatternPanel
                  retestId={locationState === undefined ? paramsId : locationState.retestId}
                  isKeyCustomer={selectedCustomer?.key_customer}
                  isKpiCustomer={selectedCustomer?.kpi_customer}
                  />
              </Grid>
            }

              {selectedSite && selectedSite.id > 0 && <Grid item xs={12} md={12} sm={12}>
                <Widget
                 className={classes.formDisplay}
                 disableWidgetMenu noHeader>
                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                   <Tabs value={siteTabValue}
                         onChange={handleSiteTabChange}
                         indicatorColor="primary"
                         textColor="primary"
                         variant="fullWidth">
                     <Tab {...a11yProps(0)} label="SITE NOTES"
                                            value={0}/>
                     <Tab {...a11yProps(1)} label="HISTORY"
                                            value={1}/>
                     <Tab {...a11yProps(2)} label="SITE DETAILS"
                                            value={2}/>
                   </Tabs>
                 </AppBar>
                 {/*<TabPanel value={siteTabValue} index={0}>
                    <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                  </TabPanel>
                   */}

                   <div
                     role="tabpanel"
                     id="simple-tabpanel-0"
                     aria-labelledby="simple-tab-0"
                   >
                     {siteTabValue === 0 && (
                       <Box p={3}>
                         <Typography component="div">
                         <UpdateSite key={selectedSite.id} isNotesOnly={true} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                         </Typography>
                       </Box>
                     )}
                   </div>
                   <div
                     role="tabpanel"
                     id="simple-tabpanel-1"
                     aria-labelledby="simple-tab-1"
                   >
                     {siteTabValue === 1 && (
                       <Box p={3}>
                         <Typography component="div">
                          <JobHistories key={selectedSite.id} jobId={oldJobId}/>
                         </Typography>
                       </Box>
                     )}
                   </div>
                   {/*<TabPanel value={siteTabValue} index={2}>
                     <UpdateSite key={selectedSite.id} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                   </TabPanel>*/}
                   <div
                     role="tabpanel"
                     id="simple-tabpanel-2"
                     aria-labelledby="simple-tab-2"
                   >
                     {siteTabValue === 2 && (
                       <Box p={3}>
                         <Typography component="div">
                          <UpdateSite key={selectedSite.id} createdSite={selectedSite} onUpdateSuccess={onUpdateSiteSuccess}/>
                         </Typography>
                       </Box>
                     )}
                   </div>


                </Widget>
              </Grid>}
              {selectedCustomer && selectedCustomer.id > 0 && <Grid item xs={12} md={12} sm={12}>
                <Widget
                 className={classes.formDisplay}
                 disableWidgetMenu noHeader>
                 <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                   <Tabs value={customerTabValue}
                         onChange={handleCustomerTabChange}
                         indicatorColor="primary"
                         textColor="primary"
                         variant="fullWidth">
                     <Tab {...a11yProps(0)} label="CUSTOMER NOTES"
                                            value={0}/>
                     <Tab {...a11yProps(1)} label="CUSTOMER DETAILS"
                                            value={1}/>
                   </Tabs>
                 </AppBar>
                 {/*<TabPanel value={customerTabValue} index={0}>
                    <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                  </TabPanel>
                  <TabPanel value={customerTabValue} index={1}>
                    <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                  </TabPanel>*/}

                  <div
                    role="tabpanel"
                    id="simple-tabpanel-customer-0"
                    aria-labelledby="simple-tab-customer-0"
                  >
                    {customerTabValue === 0 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateCustomer key={selectedCustomer.id} isNotesOnly={true} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>

                  <div
                    role="tabpanel"
                    id="simple-tabpanel-customer-1"
                    aria-labelledby="simple-tab-customer-1"
                  >
                    {customerTabValue === 1 && (
                      <Box p={3}>
                        <Typography component="div">
                        <UpdateCustomer key={selectedCustomer.id} createdCustomer={selectedCustomer} onUpdateSuccess={onUpdateCustomerSuccess}/>
                        </Typography>
                      </Box>
                    )}
                  </div>

                </Widget>
              </Grid>}

            </Grid>
          </Grid>


        </Grid>}
    </div>
    {retest !== undefined && retest !== null &&
      retest.booked_job_id !== undefined && retest.booked_job_id !== null &&
      retest.booked_job_id > 0 &&
      <Dialog open={openBookJobDialog} onClose={handleCloseBookJobDialog} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
      <DialogContent>
        <DialogContentText>
           Job&nbsp;
           <Link style={{display: 'inline-flex'}}
                  href={`${config.adminApi}/#/app/job/edit/${retest.booked_job_id}`}
                  color="#FFCA06" target="_blank">
                  {retest.booked_job_id}<OpenInNewIcon style={{width:'15px', marginTop: '-5px'}}/></Link>
           &nbsp;is already booked for this retest. Are you sure you want to create another job card?<br/>
           Please note that if you proceed, Job&nbsp;
           <Link style={{display: 'inline-flex'}}
                  href={`${config.adminApi}/#/app/job/edit/${retest.booked_job_id}`}
                  color="#FFCA06" target="_blank">
                  {retest.booked_job_id}<OpenInNewIcon style={{width:'15px', marginTop: '-5px'}}/></Link>
                  &nbsp;will be unlinked to this retest.
        </DialogContentText>

      </DialogContent>
      <DialogActions>
          <Button onClick={handleCloseBookJobDialog} className={classes.cancelButton}>
            Cancel
          </Button>
          <Button onClick={() => handleFinish(false)}>
            <span>SAVE</span>
          </Button>
          <Button onClick={() => handleFinish(true)}>
            <span>SAVE & CONFIRM</span>
          </Button>
      </DialogActions>
    </Dialog>}

    </>
  );
//}
});
export default BookJob;
